import React from "react";
import { connect } from "react-redux";
import { Popup, ScrollView } from "devextreme-react";
import AdjustAvailableUnAvailableStatus from "../locationtracking/AdjustAvailableUnAvailableStatus";

function AdjustAvailableUnAvailableStatusMainPopup(props) {
    return (<>
        {props.showPopup.visible == true && (
            <Popup
                visible={props.showPopup.visible}
                onHiding={() => props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }))}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={props.title}
                container="#root"
                width="100vw"
                height="100vh"
            >
                <ScrollView height="100%" width="100%">
                    {props.showPopup.visible == true && (<AdjustAvailableUnAvailableStatus id={props.showPopup.id} />)}
                </ScrollView>
            </Popup>
        )}
    </>

    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdjustAvailableUnAvailableStatusMainPopup);
